import React, { useState } from 'react';
import { HelpCircle } from 'lucide-react';
import OfferteForm from './OfferteForm';

function HelpButton() {
  const [isFormOpen, setIsFormOpen] = useState(false);

  return (
    <>
      <button 
        onClick={() => setIsFormOpen(true)} 
        className="fixed bottom-8 right-8 bg-[#FFD100] rounded-full w-12 h-12 flex items-center text-white justify-center shadow-lg hover:bg-[#FFD100]/80 transition-colors z-50"
      >
        <HelpCircle className="w-6 h-6" />
      </button>

      <OfferteForm 
        isOpen={isFormOpen}
        onClose={() => setIsFormOpen(false)}
      />
    </>
  );
}

export default HelpButton;